// Don't fwd props that start with '$'
exports.transient$Props = {
    shouldForwardProp: (prop) => prop[0] !== '$'
};
